export default "__VITE_ASSET__8c1ceed7__"